import { render, staticRenderFns } from "./aiConversationChat.vue?vue&type=template&id=81117044&scoped=true&"
import script from "./aiConversationChat.vue?vue&type=script&lang=js&"
export * from "./aiConversationChat.vue?vue&type=script&lang=js&"
import style0 from "./aiConversationChat.vue?vue&type=style&index=0&id=81117044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81117044",
  null
  
)

export default component.exports